import React from "react";
import { Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import metricDefinitions from "../../metricDefinitions";
import MetricCheckbox from "./MetricCheckbox";

const HiddenMetricsList = (props) => {
  const { organization_name, permissions } = useSelector(
    (state) => state.static
  );
  const { smallName } = useSelector((state) => state.selected);
  const { hiddenOutcomes } = useSelector((state) => state.settings);
  let metricsCategory = metricDefinitions(organization_name, permissions)[
    smallName
  ];

  const createSurveySlugs = () => {
    const averageMetrics = metricsCategory.averageMetrics.map((o) => {
      return {
        outcome_slug: `average_metrics_${o.slug}`,
        title: `Average Metrics: ${o.title}`,
      };
    });
    const percentChangeMetrics = metricsCategory.percentChangeMetrics.map(
      (o) => {
        return {
          outcome_slug: `percent_change_metrics_${o.slug}`,
          title: `Percent Change Metrics: ${o.title}`,
        };
      }
    );
    const averageScorePerMonthMetrics =
      metricsCategory.averageScorePerMonthMetrics.map((o) => {
        return {
          outcome_slug: `average_score_per_month_metrics_${o.slug}`,
          title: `Average Score Per Month Metrics: ${o.title}`,
        };
      });
    const percentChangePerMonthMetrics =
      metricsCategory.percentChangePerMonthMetrics.map((o) => {
        return {
          outcome_slug: `percent_score_per_month_metrics_${o.slug}`,
          title: `Percent Score Per Month Metrics: ${o.title}`,
        };
      });
    const exitSurveyMetrics = metricsCategory.exitSurveyMetrics.map((o) => {
      return {
        outcome_slug: `exit_survey_metrics_${o.endpoint}`,
        title: `Exit Survey Metrics: ${o.title}`,
      };
    });
    const dischargeSurveyMetrics = metricsCategory.dischargeSurveyMetrics.map(
      (o) => {
        return {
          outcome_slug: `discharge_survey_metrics_${o.endpoint}`,
          title: `Discharge Survey Metrics: ${o.title}`,
        };
      }
    );
    const transitionSurveyMetrics = metricsCategory.transitionSurveyMetrics.map(
      (o) => {
        return {
          outcome_slug: `transition_survey_metrics_${o.endpoint}`,
          title: `Transition Survey Metrics: ${o.title}`,
        };
      }
    );
    const basic_metrics = metricsCategory.basic_metrics.map((o) => {
      return {
        outcome_slug: `basic_metrics_${o.slug}`,
        title: `Basic Metrics: ${o.title}`,
      };
    });
    return [
      ...averageMetrics,
      ...percentChangeMetrics,
      ...averageScorePerMonthMetrics,
      ...percentChangePerMonthMetrics,
      ...exitSurveyMetrics,
      ...dischargeSurveyMetrics,
      ...transitionSurveyMetrics,
      ...basic_metrics,
    ];
  };

  let metrics =
    smallName == "surveys" ? createSurveySlugs() : metricsCategory.metrics;

  return (
    <Col>
      {metrics.map((metric) => (
        <MetricCheckbox
          key={metric.outcome_slug}
          metric={metric}
          selected={hiddenOutcomes.includes(metric.outcome_slug)}
        />
      ))}
    </Col>
  );
};

export default HiddenMetricsList;
